import _ from 'lodash'
import { JSONEditor } from '@json-editor/json-editor'

const BaseEditor = JSONEditor.defaults.editors.table

class TableEditor extends BaseEditor {
    constructor (options, defaults) {
        super(options, defaults)
        this.isBasic = options.jsoneditor.options.isBasic || false
        this.displayInBasic = this.options.displayInBasic || false
        if (this.isBasic) {
            // Set default values
            this.options.disable_array_reorder = true
            this.options.disable_array_add = true
            this.options.disable_array_delete = true
            if (this.options.basicEditorOptions) {
                _.merge(this, this.options.basicEditorOptions)
            }
        }
    }

    build () {
        super.build()
    }

    setValue (value, initial) {
        super.setValue(value, initial)
        if (this.isBasic && this.value.length === 0 && this.options.hidden !== true && this.displayInBasic !== true) {
            this.options.hidden = true
        }
    }
}

export default TableEditor
